import { render, staticRenderFns } from "./MyPhotoUpload.vue?vue&type=template&id=5bdc90bc&"
import script from "./MyPhotoUpload.vue?vue&type=script&lang=js&"
export * from "./MyPhotoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports